import { AppRoutes } from '../../src/router';

export default function Page() {
  return <AppRoutes />;
}
